var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormBuilder" } }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-text" }, [
        _c(
          "div",
          {
            class: { active: _vm.activeTab === "create" },
            on: {
              click: function ($event) {
                return _vm.setActiveTab("create")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.create")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { active: _vm.activeTab === "settings" },
            on: {
              click: function ($event) {
                return _vm.setActiveTab("settings")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.settings")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { active: _vm.activeTab === "publish" },
            on: {
              click: function ($event) {
                return _vm.setActiveTab("publish")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.load")))]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.activeTab === "create"
      ? _c("div", { attrs: { id: "form-builder" } }, [
          _c(
            "div",
            { staticClass: "edit-menu" },
            [
              !_vm.openMenu
                ? _c(
                    "div",
                    {
                      staticClass: "edit-menu-open",
                      on: { click: _vm.openEditMenu },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("form.insertFormField")) +
                          "\n                "
                      ),
                      _c("span", { staticClass: "md-icon" }, [_vm._v("add")]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "slide" } },
                [
                  _vm.openMenu
                    ? _c("ItemMenu", {
                        staticClass: "item-menu",
                        on: { close: _vm.closeEditMenu },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "edit-form-content",
              on: {
                dragover: function ($event) {
                  $event.preventDefault()
                },
                drop: _vm.onDrop,
              },
            },
            [
              _vm.form.logo.length
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "max-width": "100px",
                        "max-height": "100px",
                        margin: "auto",
                        padding: "5px",
                      },
                    },
                    _vm._l(_vm.form.logo, function (logo) {
                      return _c(
                        "div",
                        { key: logo._id, staticStyle: { display: "flex" } },
                        [
                          _c("img", {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              "object-fit": "contain",
                            },
                            attrs: {
                              src:
                                "https://static.supsis.live/" +
                                (logo.path + logo._id) +
                                "." +
                                logo.ext,
                              alt: logo.name,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.$t(
                                      "form.clickToDeleteYourLogo"
                                    ),
                                    placement: "top",
                                  },
                                  expression:
                                    "{ content: $t('form.clickToDeleteYourLogo'), placement: 'top' }",
                                },
                              ],
                              staticClass: "md-icon",
                              staticStyle: {
                                color: "#ff411cf5",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteLogo(logo._id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        delete\n                    "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    {
                      staticClass: "add-logo",
                      on: { click: _vm.openFileInput },
                    },
                    [
                      _c("div", { staticClass: "line" }),
                      _vm._v(" "),
                      _c("input", {
                        staticStyle: { display: "none" },
                        attrs: { id: "fileInput", type: "file" },
                        on: { change: _vm.uploadFile },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("+ " + _vm._s(_vm.$t("form.addYourLogo"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "line" }),
                    ]
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-edit" },
                [
                  _c(
                    "draggable",
                    {
                      on: { end: _vm.onEnd },
                      model: {
                        value: _vm.formItems,
                        callback: function ($$v) {
                          _vm.formItems = $$v
                        },
                        expression: "formItems",
                      },
                    },
                    _vm._l(_vm.formItems, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "form-item",
                          class: { active: _vm.activeIndex === index },
                          attrs: { "data-index": index },
                          on: {
                            click: function ($event) {
                              return _vm.setActive(index)
                            },
                          },
                        },
                        [
                          item.type === "title"
                            ? _c("Title", {
                                attrs: {
                                  item: item,
                                  "title-size": item.titleSize,
                                  "title-align": item.titleAlign,
                                  "title-text": item.titleText,
                                  "sub-title": item.subTitle,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "fullName"
                            ? _c("FullName", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  "full-name-align": item.fullNameAlign,
                                  "first-name": item.firstName,
                                  "last-name": item.lastName,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "email"
                            ? _c("Email", {
                                attrs: {
                                  item: item,
                                  "field-email": item.fieldEmail,
                                  "mail-align": item.mailAlign,
                                  "alt-label": item.altLabel,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "address"
                            ? _c("Address", {
                                attrs: {
                                  "field-address": item.fieldAddress,
                                  align: item.align,
                                  item: item,
                                  "address-line1": item.addressLine1,
                                  "address-line2": item.addressLine2,
                                  district: item.district,
                                  "postal-code": item.postalCode,
                                  state: item.state,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "phone"
                            ? _c("Phone", {
                                attrs: {
                                  item: item,
                                  "field-phone": item.fieldPhone,
                                  align: item.align,
                                  masked: item.masked,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "datePicker"
                            ? _c("DatePicker", {
                                attrs: {
                                  item: item,
                                  align: item.align,
                                  "date-label": item.dateLabel,
                                  "field-label": item.datePicker.fieldLabel,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "meeting" ? _c("Meeting") : _vm._e(),
                          _vm._v(" "),
                          item.type === "signature"
                            ? _c("Signature")
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "listOfProducts"
                            ? _c("ListOfProducts")
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "shortText"
                            ? _c("ShortText", {
                                attrs: {
                                  "field-label": item.fieldLabel,
                                  item: item,
                                  align: item.align,
                                  "alt-label": item.altLabel,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "longText"
                            ? _c("LongText", {
                                attrs: {
                                  "field-label": item.fieldLabel,
                                  align: item.align,
                                  item: item,
                                  "alt-label": item.altLabel,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "paragraph"
                            ? _c("Paragraph")
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "dropDownList"
                            ? _c("DropDownList", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  placeholder: item.placeholder,
                                  align: item.align,
                                  "alt-label": item.altLabel,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "singleChoice"
                            ? _c("SingleChoice", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  align: item.align,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "multipleSelection"
                            ? _c("MultipleSelection", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  align: item.align,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "number"
                            ? _c("Number", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  align: item.labelAlign,
                                  "sub-label": item.subLabel,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "image" ? _c("Image") : _vm._e(),
                          _vm._v(" "),
                          item.type === "fileUpload"
                            ? _c("FileUpload", {
                                attrs: {
                                  item: item,
                                  "field-label-file": item.fieldLabelFile,
                                  align: item.align,
                                  "alt-label-one": item.altLabelOne,
                                  "alt-label-two": item.altLabelTwo,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "hour"
                            ? _c("Hour", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  align: item.align,
                                  "hour-label": item.hourLabel,
                                  "minute-label": item.minuteLabel,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "spinner"
                            ? _c("Spinner", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  align: item.align,
                                  "is-required": item.isRequired,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "send"
                            ? _c("Send", {
                                attrs: {
                                  item: item,
                                  label: item.fieldLabel,
                                  align: item.align,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "dataTable"
                            ? _c("DataTable")
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "starRating"
                            ? _c("StarRating", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  align: item.align,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "ratingScale"
                            ? _c("RatingScale", {
                                attrs: {
                                  item: item,
                                  "field-label": item.fieldLabel,
                                  align: item.align,
                                  "sub-label-one": item.subLabelOne,
                                  "sub-label-two": item.subLabelTwo,
                                },
                                on: { "update-field": _vm.updateField },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "separationElement"
                            ? _c("SeparationElement", {
                                attrs: {
                                  "separation-color": item.separationColor,
                                  "separator-bottom": item.separatorBottom,
                                  "separator-height": item.separatorHeight,
                                  "separator-side": item.separatorSide,
                                  "separator-style": item.separatorStyle,
                                  "separator-top": item.separatorTop,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "collapseSection"
                            ? _c("CollapseSection")
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === "pageBreak"
                            ? _c("PageBreak")
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-controls",
                              class: { visible: _vm.activeIndex === index },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "md-icon",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeItem(index)
                                    },
                                  },
                                },
                                [_vm._v("delete")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "md-icon",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.openSettings(item, item.type)
                                    },
                                  },
                                },
                                [_vm._v("settings")]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-menu" },
            [
              _c("transition", { attrs: { name: "slideRight" } }, [
                _vm.openSettingsMenu
                  ? _c(
                      "div",
                      { staticClass: "settings-menu" },
                      [
                        _c("SettingsMenu", {
                          attrs: {
                            item: _vm.settingsMenuItem,
                            type: _vm.settingsMenuType,
                          },
                          on: {
                            close: function ($event) {
                              _vm.openSettingsMenu = false
                            },
                            "update-title-size": _vm.updateTitleSize,
                            "update-text-align": _vm.updateTextAlign,
                            "update-title-text": _vm.updateTitleText,
                            "update-subtitle-text": _vm.updateSubTitleText,
                            "update-field-label": _vm.updateFieldLabel,
                            "update-label-align": _vm.updateLabelAlign,
                            "update-first-name": _vm.updateFirstName,
                            "update-last-name": _vm.updateLastName,
                            "update-field-email": _vm.updateFieldEmail,
                            "update-label-align-mail": _vm.updateLabelAlignMail,
                            "update-alt-label-mail": _vm.updateAltLabelMail,
                            "update-field-label-address":
                              _vm.updateFieldLabelAddress,
                            "update-label-align-address":
                              _vm.updateLabelAlignAddress,
                            "update-field-address-line-1":
                              _vm.updateFieldAddressLine1,
                            "update-field-address-line-2":
                              _vm.updateFieldAddressLine2,
                            "update-field-district": _vm.updateFieldDistrict,
                            "update-field-postal-code":
                              _vm.updateFieldPostalCode,
                            "update-field-state": _vm.updateFieldState,
                            "update-field-phone": _vm.updateFieldPhone,
                            "update-label-align-phone":
                              _vm.updateLabelAlignPhone,
                            "update-masked-phone": _vm.updateMaskedPhone,
                            "update-field-label-date-picker":
                              _vm.updateFieldLabelDatePicker,
                            "update-label-align-date-picker":
                              _vm.updateLabelAlignDatePicker,
                            "update-date-label-date-picker":
                              _vm.updateDateLabelDatePicker,
                            "update-field-label-short-text":
                              _vm.updateFieldLabelShortText,
                            "update-label-align-short-text":
                              _vm.updateLabelAlignShortText,
                            "update-alt-label-short-text":
                              _vm.updateAltLabelShortText,
                            "update-field-label-long-text":
                              _vm.updateFieldLabelLongText,
                            "update-label-align-long-text":
                              _vm.updateLabelAlignLongText,
                            "update-alt-label-long-text":
                              _vm.updateAltLabelLongText,
                            "update-field-label-drop-down-list":
                              _vm.updateFieldLabelDropDownList,
                            "update-placeholder-drop-down-list":
                              _vm.updatePlaceholderDropDownList,
                            "update-label-align-drop-down-list":
                              _vm.updateLabelAlignDropDownList,
                            "update-alt-label-drop-down-list":
                              _vm.updateAltLabelDropDownList,
                            "update-field-label-single-choice":
                              _vm.updateFieldLabelSingleChoice,
                            "update-label-align-single-choice":
                              _vm.updateLabelAlignSingleChoice,
                            "update-field-label-multiple-selection":
                              _vm.updateFieldLabelMultipleSelection,
                            "update-label-align-multiple-selection":
                              _vm.updateLabelAlignMultipleSelection,
                            "update-field-label-number":
                              _vm.updateFieldLabelNumber,
                            "update-label-align-number":
                              _vm.updateLabelAlignNumber,
                            "update-sub-label-number": _vm.updateSubLabelNumber,
                            "update-field-label-hour": _vm.updateFieldLabelHour,
                            "update-label-align-hour": _vm.updateLabelAlignHour,
                            "update-hour-label": _vm.updateHourLabel,
                            "update-minute-label": _vm.updateMinuteLabel,
                            "update-field-label-spinner":
                              _vm.updateFieldLabelSpinner,
                            "update-label-align-spinner":
                              _vm.updateLabelAlignSpinner,
                            "update-field-label-star-rating":
                              _vm.updateFieldLabelStarRating,
                            "update-alignment-star-rating":
                              _vm.updateAlignmentStarRating,
                            "update-field-label-rating-scale":
                              _vm.updateFieldLabelRatingScale,
                            "update-field-label-send": _vm.updateFieldLabelSend,
                            "update-label-align-send": _vm.updateAlignmentSend,
                            "update-alignment-rating-scale":
                              _vm.updateAlignmentRatingScale,
                            "update-sub-label-one-rating-scale":
                              _vm.updateRatingScaleSubLabelOne,
                            "update-sub-label-two-rating-scale":
                              _vm.updateRatingScaleSubLabelTwo,
                            "update-separation-color":
                              _vm.updateSeparationColor,
                            "update-separator-style": _vm.updateSeparatorStyle,
                            "update-separator-height":
                              _vm.updateSeparatorHeight,
                            "update-separator-bottom":
                              _vm.updateSeparatorBottom,
                            "update-separator-top": _vm.updateSeparatorTop,
                            "update-separator-side": _vm.updateSeparatorSide,
                            "update-file-label": _vm.updateFileLabel,
                            "update-file-alt-label-one":
                              _vm.updateFileAltLabelOne,
                            "update-file-alt-label-two":
                              _vm.updateFileAltLabelTwo,
                            "update-file-align": _vm.updateFileAlign,
                            "update-required": _vm.updateRequired,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activeTab === "settings"
      ? _c(
          "div",
          [
            _c("Settings", {
              attrs: { "form-id": _vm.formId, "site-id": _vm.site._id },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.activeTab === "publish"
      ? _c(
          "div",
          [
            _c("Publish", {
              attrs: { "form-id": _vm.formId, "site-id": _vm.site._id },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }